export function doesScriptExists(url: string) {
  const scripts = document.getElementsByTagName('script');
  for (const script of Array.from(scripts)) {
    if (script.getAttribute('src') === url) {
      return true;
    }
  }
  return false;
}
